import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FieldDefinition} from '@shared/models/field-definition';
import {Router} from '@angular/router';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {CellComponent} from '@shared/components/cell-components/cell-component';

@Component({
    standalone: false,
    selector: 'particle-expert-services-edit-string-cell-viewer',
  templateUrl: './edit-expert-services-string-cell-viewer.component.html',
  styleUrls: ['./edit-expert-services-string-cell-viewer.component.scss']
})
export class EditExpertServicesStringCellViewerComponent implements OnInit, CellComponent {
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  sourceType: string;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  icon: string;
  disabled: boolean;
  editField = true;

  constructor() {
  }

  ngOnInit() {
    this.disableEditingField(this.item?.cells?.FieldKey?.value?.fieldValues?.IsImmutableDataType);
  }

  private disableEditingField(isFieldImmutable) {
    if (isFieldImmutable === true) {
      this.editField = false;
    }
  }

  onClicked(action: string) {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: action}});
  }
}
